import { MouseEvent } from "react";

export function isControlKeyPressed(event: MouseEvent<HTMLElement>) {
  return event.ctrlKey || event.metaKey;
}
